import { useState } from 'react';

import { useSidebarGroupsState } from '../_states/sidebar-groups';

export type CustomGroup = { id: string; label: string; moduleIds: string[] };

export function useCustomGroups() {
  const updateGroups = useSidebarGroupsState((s) => s.update);
  const groups = useSidebarGroupsState((s) => s.groups);

  const [isEditMode, setIsEditMode] = useState(false);
  const [newGroupLabel, setNewGroupLabel] = useState('');

  const customGroups: CustomGroup[] = groups ?? [];

  const addGroup = () => {
    const label = newGroupLabel.trim();
    if (!label) return;

    updateGroups({ groups: [...customGroups, { id: crypto.randomUUID(), label, moduleIds: [] }] });
    setNewGroupLabel('');
  };

  const removeGroup = ({ groupId }: { groupId: string }) => {
    updateGroups({ groups: customGroups.filter((group: CustomGroup) => group.id !== groupId) });
  };

  const assignModuleToGroup = ({
    moduleId,
    groupId,
  }: {
    moduleId: string;
    groupId: string | 'none';
  }) => {
    const updatedGroups = customGroups.map((group: CustomGroup) => ({
      ...group,
      moduleIds: group.moduleIds.filter((id: string) => id !== moduleId),
    }));

    if (groupId !== 'none') {
      const groupIndex = updatedGroups.findIndex((group: CustomGroup) => group.id === groupId);
      if (groupIndex >= 0) {
        updatedGroups[groupIndex] = {
          ...updatedGroups[groupIndex],
          moduleIds: [...updatedGroups[groupIndex].moduleIds, moduleId],
        };
      }
    }

    updateGroups({ groups: updatedGroups });
  };

  const toggleEditMode = () => setIsEditMode((prev) => !prev);

  return {
    customGroups,
    isEditMode,
    newGroupLabel,
    setNewGroupLabel,
    addGroup,
    removeGroup,
    assignModuleToGroup,
    toggleEditMode,
  };
}
